import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const MemberCard = ({ member }) => {
  return (
    <Card className="bg-gradient-to-br from-gray-900 to-gray-800 border-red-600 shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105">
      <CardContent className="p-6 text-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="relative">
            <img
              src={member.photo}
              alt={member.name}
              className="w-20 h-20 rounded-full border-4 border-red-600 shadow-lg"
            />
            <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-gradient-to-br from-red-600 to-red-800 rounded-full flex items-center justify-center shadow-lg">
              <span className="text-white text-xs font-bold">
                {member.country.substring(0, 2).toUpperCase()}
              </span>
            </div>
            {member.isLive && (
              <div className="absolute -top-2 -left-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center shadow-lg animate-pulse">
                <div className="w-3 h-3 bg-white rounded-full animate-ping"></div>
              </div>
            )}
          </div>
          <div className="space-y-2">
            <h3 className="text-lg font-semibold text-white">{member.name}</h3>
            <p className="text-red-300 text-sm font-medium">{member.country}</p>
            {member.isLive && (
              <div className="flex items-center justify-center space-x-1">
                <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                <span className="text-red-400 text-xs font-bold animate-pulse">
                  LIVE • {member.viewers} viewers
                </span>
              </div>
            )}
          </div>
          <Button
            onClick={() => window.open(member.twitchUrl, '_blank')}
            className={`w-full font-medium py-2 px-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg ${
              member.isLive 
                ? 'bg-gradient-to-r from-red-500 to-red-700 hover:from-red-600 hover:to-red-800 animate-pulse'
                : 'bg-gradient-to-r from-purple-600 to-purple-800 hover:from-purple-700 hover:to-purple-900'
            } text-white`}
          >
            <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/>
            </svg>
            {member.isLive ? 'Watch Live Stream!' : 'Watch on Twitch'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default MemberCard;